import { render, staticRenderFns } from "./closeDialog.vue?vue&type=template&id=1f3dc3ae&scoped=true"
import script from "./closeDialog.vue?vue&type=script&lang=js"
export * from "./closeDialog.vue?vue&type=script&lang=js"
import style0 from "./closeDialog.vue?vue&type=style&index=0&id=1f3dc3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3dc3ae",
  null
  
)

export default component.exports